module.exports = __webpack_public_path__ + "img/chatYes.2e3df746.svg";